<script>
import { services } from '@utils/common-services'
export default {
  components: {},
  props: {
    createMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
    editMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
    deleteMenu: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      trySpin: false,
      roleName: null,
      permissions: null,
      permission: null,
      perPage: 10,
      currentPage: 1,
      resendEmail: null,
      currentTab: 'uk',
      search: null,
      errorShow: null,
      deleteId: null,
      links: null,
      loading: false,
      message: null,
      fields: ['firstName', 'surname', 'email', 'phoneNumber'],
    }
  },

  beforeMount() {
    if (this.editMenu || this.deleteMenu) this.fields.push('action')
    this.getUsers(
      '/accounts/users?filter[role]=Staff&include=role,user_profile'
    )
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'user' } })
  },
  methods: {
    listAll() {
      this.search = null
      if (this.editMenu || this.deleteMenu) this.fields.push('action')
      this.getUsers(
        '/accounts/users?filter[role]=Staff&include=role,user_profile'
      )
    },
    resendInvitation() {
      this.trySpin = true
      var requestPayload = {
        email: this.resendEmail,

        _jv: {
          type: 'resend_invitation',
        },
      }
      this.$store
        .dispatch('jv/post', [
          requestPayload,
          {
            url: '/accounts/invitation/resend',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.$bvModal.hide('resend')
          this.trySpin = false
          //  console.log(response._jv.json.data.detail)

          this.message = response._jv.json.data.detail
          this.errorShow = false
          this.$bvToast.show('deleteRecord')

          var parent = this
          setTimeout(() => {
            parent.errorShow = false
            parent.$bvToast.hide('deleteRecord')
            parent.message = null
          }, 6000)
        })
        .catch((error) => {
          //  console.log(error)
          if (error) {
            this.$bvModal.hide('resend')
            this.trySpin = false
            if (error.response !== undefined)
              this.message = error.response.data.errors[0].detail
            else
              this.message =
                'Something went wrong. Check your network connection'
            this.errorShow = true
            this.$bvToast.show('deleteRecord')

            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('deleteRecord')
              parent.message = null
            }, 6000)
          }
          //   console.log(error)
        })
    },
    callInvitation(id) {
      this.options = []
      this.selected = []
      var data = this.$store.getters['jv/get']('user')
      var Item = data[id]
      // console.log(Item)
      this.resendEmail = Item.email
      // var option=[{text:Item.user.userProfile.fullName+'('+Item.user.email+')',value:'applicant1'}]

      this.$bvModal.show('resend')
    },
    editStaff(id) {
      this.$emit('edit', id)
    },
    deleteStaff(id) {
      this.$bvModal.show('delete')
      this.deleteId = id
    },
    deleteRecord() {
      var id = this.deleteId

      this.$store
        .dispatch('jv/delete', [
          'user',
          {
            url: '/accounts/users/' + id,
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then(() => {})
        .catch((err) => {
          if (err.response !== undefined) {
            this.message = err.response.data.errors[0].detail

            //  console.log(id)
            this.message = 'Something went wrong. Check your network connection'
            this.errorShow = true
            this.$bvToast.show('deleteRecord')

            var parent = this
            setTimeout(() => {
              parent.errorShow = false
              parent.$bvToast.hide('deleteRecord')
              parent.message = null
            }, 6000)
          }
        })
      this.message = 'Requested record is deleted'
      this.$bvModal.hide('delete')
      this.$bvToast.show('deleteRecord')
      var parent = this
      setTimeout(() => {
        parent.errorShow = false
        parent.$bvToast.hide('deleteRecord')
        parent.message = null
        parent.setPermission()
      }, 5000)
      //  console.log(id)
      this.$store.commit('jv/deleteRecord', {
        _jv: { type: 'user', id: id },
      })

      //  var check = this.$store.getters['jv/get']('user')
    },

    getData(to) {
      var link = this.links[to]
      if (link !== null) {
        var splites = link.split('/v1')

        this.getUsers(splites[1], this.currentTab)
      }
    },
    /*  getAll(link, save) {
            if (save === null) save = 'all'
            this.preloader = true
            return this.send({ to: '/candidates' + link, state: 'get' })
                .then((data) => {
                    //  console.log(data)
                    if (data.data !== undefined) {
                        this.setData(data, save)
                        this.allFields = jsonData.fields
                        this.preloader = false

                        //      console.log(this.allItems)
                        //   this.showInvited()
                    } else throw data
                })
                .catch((error) => {
                    if (error) this.items = []
                    this.preloader = false
                })
        }, */

    searchItem() {
      if (this.search !== null && this.search !== '') {
        this.preloader = true
        var statusFilter = ''

        statusFilter = this.search

        this.getUsers(
          '/accounts/users?filter[role]=Staff&include=role,user_profile&filter[search]=' +
            statusFilter
        )
      }
    },
    getUsers(url, tab) {
      this.loading = true
      this.$store
        .dispatch('jv/get', [
          'user',
          {
            url: url,
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.links = response._jv.json.links

          this.loading = false
          this.setPermission()
        })
    },
    setPermission() {
      this.permissions = []
      var check = this.$store.getters['jv/get']('user')

      var id = Object.keys(check)

      var data = null
      let userProfile = {}

      for (var i = id.length - 1; i >= 0; i--) {
        data = check[id[i]]._jv.attrs
        data['id'] = id[i]

        userProfile = check[id[i]].userProfile

        if (userProfile !== undefined) {
          Object.assign(data, userProfile)

          this.permissions.push(data)
          data = null
        } else {
          this.permissions.push(data)
          data = null
        }
      }
      //  console.log(this.permissions)
    },
  },
}
</script>
<template>
  <div>
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper" class="pb30-sm">
        <div :class="$style.profileSettings">
          <div :class="$style.bodyContent">
            <div :class="$style.breadCrumbWraper">
              <h4
                >Staff
                <BIcon
                  :class="$style.actionIcon"
                  class="mr5"
                  icon="chevron-right"
                ></BIcon>
                <span>List</span>
              </h4>
            </div>
          </div>
          <div class="clear"></div>
          <div :class="$style.form">
            <div>
              <div :class="$style.candidateAction">
                <form>
                  <div
                    :class="[$style.searchCandidate, $style.inputField]"
                    class="mr10 mb10-sm"
                  >
                    <input
                      v-model="search"
                      type="text"
                      name="search"
                      placeholder="Search"
                    />
                    <button
                      :class="$style.searchButton"
                      type="button"
                      @click="searchItem"
                      ><BIcon :class="$style.completed" icon="search"></BIcon
                    ></button>
                  </div>
                </form>
                <div class="FR">
                  <button
                    v-if="createMenu"
                    :class="$style.createButton"
                    class="buttonCommon m0auto-xs db FL"
                    @click="$emit('create', true)"
                  >
                    <span>+</span> Invite Staff
                  </button>
                  <button
                    v-if="search !== null && search !== ''"
                    :class="$style.createButton"
                    class="buttonCommon ml10 FL"
                    @click="listAll"
                    ><BIcon icon="eye" class="mr5 mr0-sm"></BIcon>View all
                    Staffs
                  </button>
                </div>
              </div>
              <div class="clear"></div>
              <div :class="[$style.candidateWraper]" class="mt10">
                <div :class="$style.tabContentWrap">
                  <template>
                    <div :class="$style.rolesTable" class="mt10">
                      <b-table
                        v-if="loading"
                        :items="permissions"
                        :busy="loading"
                        class="mt-3"
                        outlined
                      >
                        <template v-slot:table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                      </b-table>
                      <b-table
                        v-else
                        show-empty
                        stacked="md"
                        responsive="sm"
                        borderless
                        :items="permissions"
                        :fields="fields"
                        head-variant="light"
                      >
                        <template
                          v-if="editMenu || deleteMenu"
                          v-slot:cell(action)="row"
                        >
                          <a
                            :id="row.item.id + 'uk'"
                            href="javascript:void(0)"
                            variant="primary"
                            :class="[$style.actionsBtn, $style.animate]"
                          >
                            <BIcon
                              icon="gear-fill"
                              :class="$style.actionIcon"
                            ></BIcon>
                          </a>
                          <b-popover
                            :target="row.item.id + 'uk'"
                            placement="bottom"
                            triggers="hover"
                            :class="$style.popoverWraper"
                            boundary-padding="1"
                          >
                            <b-list-group flush>
                              <b-list-group-item
                                v-if="editMenu"
                                href="javascript:void(0)"
                                @click="editStaff(row.item.id)"
                                ><BIcon icon="pencil" class="mr5"></BIcon
                                >Edit</b-list-group-item
                              >
                              <b-list-group-item
                                href="javascript:void(0)"
                                @click="callInvitation(row.item.id)"
                                ><BIcon icon="envelope" class="mr5"></BIcon
                                >Resend Invitation</b-list-group-item
                              >
                              <b-list-group-item
                                v-if="deleteMenu"
                                href="javascript:void(0)"
                                @click="deleteStaff(row.item.id)"
                                ><BIcon icon="trash" class="mr5"></BIcon
                                >Delete</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </template>
                      </b-table>
                    </div>
                  </template>
                </div>
                <!--  <div :class="$style.tabContentWrap">
                  <template>
                    <div :class="$style.rolesTable" class="mt10">
                      <b-table
                        id="my-table"
                        show-empty
                        :per-page="perPage"
                        :current-page="currentPage"
                        stacked="lg"
                        responsive="sm"
                        borderless
                        :items="permissions"
                        :fields="fields"
                        head-variant="light"
                      >
                        <template
                          v-if="editMenu || deleteMenu"
                          v-slot:cell(action)="row"
                        >
                          <a
                            :id="row.item.id + 'scotland'"
                            href="javascript:void(0)"
                            variant="primary"
                            :class="[$style.actionsBtn, $style.animate]"
                          >
                            <BIcon
                              icon="gear-fill"
                              :class="$style.actionIcon"
                            ></BIcon>
                          </a>
                          <b-popover
                            :target="row.item.id + 'scotland'"
                            placement="bottom"
                            triggers="focus"
                            :class="$style.popoverWraper"
                            boundary-padding="1"
                          >
                            <b-list-group flush>
                              <b-list-group-item
                                v-if="editMenu"
                                href="javascript:void(0)"
                                @click="editStaff(row.item.id)"
                                >Edit</b-list-group-item
                              >
                              <b-list-group-item
                                v-if="deleteMenu"
                                href="javascript:void(0)"
                                @click="deleteStaff(row.item.id)"
                                >Delete</b-list-group-item
                              >
                            </b-list-group>
                          </b-popover>
                        </template>
                      </b-table>
                    </div>
                  </template>
                </div> -->
              </div>
              <div class="mt20">
                <nav
                  v-if="links !== null"
                  class="FL"
                  aria-label="Page navigation pagination"
                >
                  <ul class="pagination justify-content-end">
                    <li
                      class="page-item"
                      :class="
                        links.first === null || links.first == undefined
                          ? 'disabled'
                          : ''
                      "
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        :class="$style.linkText"
                        @click="getData('first')"
                        >First</a
                      >
                    </li>

                    <li
                      :class="
                        links['prev'] === null || links.prev === undefined
                          ? ['page-item disabled']
                          : ['page-item']
                      "
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        :class="$style.linkText"
                        @click="getData('prev')"
                        >Prev</a
                      >
                    </li>
                    <li
                      :class="
                        links.next === null || links.next === undefined
                          ? ['disabled page-item']
                          : ['page-item']
                      "
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        :class="$style.linkText"
                        @click="getData('next')"
                        >Next</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="
                        links.last === null || links.last === undefined
                          ? 'disabled'
                          : ''
                      "
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        :class="$style.linkText"
                        @click="getData('last')"
                        >Last
                      </a>
                    </li>
                  </ul>
                </nav>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>

    <!--Address Modal popup -->
    <div> </div>
    <!--Address Modal popup -->

    <!--Profile upload Modal popup -->
    <div>
      <!-- <b-button v-b-modal.modal-profile-upload>Launch centered modal</b-button> -->
      <div>
        <b-modal
          id="resend"
          centered
          title="BootstrapVue"
          hide-header
          hide-footer
          size="md"
          :class="$style.modalOverall"
        >
          <div :class="[$style.modalWraper, $style.planeModal]">
            <div :class="$style.modalHeader">
              <h3 :class="$style.modalTitle">Confirmation</h3>
              <span :class="$style.modalIcon"></span>
            </div>
            <div class="clear"></div>
            <div :class="$style.modalBody">
              <p :class="$style.modalText"
                >Do you want to resend invitation to the following
                applicant(s)?</p
              >
              <div class="clear"></div>
              <div :class="[$style.buttonWrapper]" class="tc mt30">
                <button
                  type="button"
                  class="buttonCommon buttonCancel button mr10"
                  @click="$bvModal.hide('resend')"
                >
                  Cancel
                </button>
                <button
                  class="buttonCommon buttonPrimary button"
                  type="button"
                  @click="resendInvitation"
                >
                  <b-spinner
                    v-if="trySpin"
                    style="width: 18px; height: 18px;"
                    class="ml15 mr15"
                    label="Spinning"
                  ></b-spinner>
                  {{ !trySpin ? 'Confirm' : '' }}
                </button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
      <div>
        <b-modal
          id="delete"
          centered
          title="BootstrapVue"
          hide-header
          hide-footer
          size="md"
          :class="$style.modalOverall"
        >
          <div :class="[$style.modalWraper, $style.planeModal]">
            <div :class="$style.modalHeader">
              <h3 :class="$style.modalTitle">Confirmation</h3>
              <span :class="$style.modalIcon"></span>
            </div>
            <div class="clear"></div>
            <div :class="$style.modalBody">
              <p :class="$style.modalText"
                >Do you want to delete this record?</p
              >
              <div class="clear"></div>
              <div :class="[$style.buttonWrapper]" class="tc mt30">
                <button
                  type="button"
                  class="buttonCommon buttonCancel button mr10"
                  @click="$bvModal.hide('delete')"
                >
                  Cancel
                </button>
                <button
                  class="buttonCommon buttonPrimary button"
                  type="button"
                  @click="deleteRecord"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>

    <div :class="$style.toasterMainWrap">
      <b-toast id="deleteRecord" solid no-auto-hide>
        <div
          class="d-flex"
          :class="
            errorShow
              ? [$style.loginToasterWraper, $style.error]
              : [$style.loginToasterWraper, $style.success]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';
::placeholder {
  color: #c3c8cc;
}

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  &.planeModal {
    .modalHeader {
      padding: 25px 30px 5px 30px;
      background: #fff;
      border: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .modalIcon {
      display: block;
      width: 100px;
      height: 100px;
      margin: 20px auto;
      background: url('~@assets/images/information.png') no-repeat;
      transform: scale(0.9);
      transform-origin: top;
    }
    .modalTitle {
      float: none;
      text-align: center;
    }
    .modalText {
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: #818284;
      text-align: center;
    }
    .modalBody {
      padding: 0 30px 40px 30px;
    }
  }
}
// Modal

// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

// toaster
.loginToasterWraper {
  &.error {
    .toasterLeft {
      float: left;
      padding: 20px;
      color: $color-background-text;
      background: $color-error;
    }

    .toasterRight {
      float: left;
      padding: 10px;
      color: #707574;
      background: $color-background-text;
    }
  }

  &.success {
    .toasterLeft {
      float: left;
      padding: 20px;
      color: $color-background-text;
      background: $color-success;
    }

    .toasterRight {
      float: left;
      padding: 10px;
      color: #707574;
      background: $color-background-text;
    }
  }

  p {
    margin: 0;
    color: #333;
  }

  svg {
    position: relative;
    top: calc(50% - 11px);
    font-size: 20px;
  }
}
// toaster

.popoverWraper {
  padding: 0 !important;
}
.searchCandidate {
  position: relative;
  float: left;
  width: 200px;
  overflow: hidden;
  border-radius: 50px;

  input,
  select {
    width: 100%;
    padding: 8px 10px;
    background: #f8fafb;
    border-color: #f9ba9f !important;
    border-radius: 50px;
  }

  button,
  span {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding: 8px 14px;
    color: #fff;
    background: #ff5d16;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

    svg {
      font-size: 17px;
    }
  }
}

.createButton {
  padding: 8px 20px !important;
  overflow: hidden;
  font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px !important;
  color: #fff;
  background-color: #ff5d16;
  border-radius: 50px !important;
}

.actionsBtn {
  position: relative;
  display: block;
  width: 26px;
  height: 26px;
  color: #455d73;
  background: #fff !important;
  border: 1px solid #455d73 !important;
  border-radius: 50px !important;

  .actionIcon {
    position: absolute;
    top: 5px;
    left: 5px;
    color: #455d73;
    transition: all ease-in-out;
    transform: rotate(0deg) 0.2s;
  }

  &.animate:hover {
    .actionIcon {
      color: #455d73;
      transition: all ease-in-out 0.2s;
      transform: rotate(90deg);
    }
  }
}

.table {
  margin-bottom: 0 !important;
}
.rolesTable {
  display: block;
  width: 100%;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 10px;

  table {
    margin: 0 !important;
    border: 0 !important;
  }

  th {
    background-color: #f9f9fb !important;
    border: none !important;
    border-bottom: 1px solid #e8e8e8 !important;
    div {
      font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji !important;
      font-size: 15px !important;
      color: #4b545e !important;
    }
  }

  td {
    position: relative;
    padding: 15px !important;

    div {
      font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji !important;
      font-size: 14px !important;
      color: #4b545e !important;
      word-break: break-word;
      vertical-align: middle;
    }
  }

  tr:nth-child(even) {
    background-color: #f9f9fb;
  }
  .actionList {
    z-index: 10;
  }
}

// Table

.form {
  padding: 20px 30px;
}
.formGroup {
  max-width: 500px;
}
// breadcrumb

.profileSettings {
  float: left;
  width: 100%;
}

// Page Title - Info text
.bodyContent {
  float: left;
  width: 100%;
}
// Page Title - Info text

.mainWraper {
  width: 100%;
  min-height: calc(100vh - 55px);
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  min-height: calc(100vh - 85px);
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

@media (max-width: 767px) {
  .mainWraper {
    padding: 0 !important;
  }
  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .profileSettings {
    padding: 0;
  }

  .createButton {
    display: block;
    width: 38px;
    height: 38px;
    padding: 0 !important;
    font-size: 25px !important;
    line-height: 38px;
    color: transparent;
    border-radius: 50px !important;

    span {
      color: #fff !important;
    }

    svg {
      font-size: 20px;
      color: #fff !important;
    }
  }

  .rolesTable {
    table {
      tbody {
        td::after {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 1px;
          content: '';
          background: #ececec;
        }
      }
    }
  }
}
</style>
